<template>
    <div class="top-right-btn">
        <el-row>
<!--            <el-tooltip class="item" effect="dark" :content="showSearch ? '隐藏搜索' : '显示搜索'" placement="top">-->
<!--                <el-button size="mini" circle icon="el-icon-search" @click="toggleSearch()" />-->
<!--            </el-tooltip>-->
<!--            <el-tooltip class="item" effect="dark" content="刷新" placement="top">-->
<!--                <el-button size="mini" circle icon="el-icon-refresh" @click="refresh()" />-->
<!--            </el-tooltip>-->

            <el-tooltip class="item" effect="dark" content="显隐列" placement="top" v-if="columns!=undefined">
                <el-dropdown trigger="click" :hide-on-click="false" style="padding-left: 12px" ref="hideIt">
                    <el-button size="mini" circle icon="el-icon-menu"/>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="item in columns" :key="item.id">
                            <el-checkbox :checked="item.isShow" @change="monitorChange($event,item.label)" :label="item.label"
                                         :v-bind="item.id"

                                         ></el-checkbox>
<!--                            v-if="item.prop != 'op'"-->
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-tooltip>

        </el-row>
        <el-dialog :title="title" :visible.sync="open" append-to-body>
            <el-transfer
                    :titles="['显示', '隐藏']"
                    v-model="value"
                    :data="columns"
                    @change="dataChange"
            ></el-transfer>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: "RightToolbar",
        data() {
            return {

                // 显隐数据
                value: [],
                // 弹出层标题
                title: "显示/隐藏",
                // 是否显示弹出层
                open: false,
            };
        },
        props: {
            //pageName:{type:String},
            showSearch: {
                type: Boolean,
                default: true,
            },
            columns: {
                type: Array,
            },
        },
        created() {
        },
        methods: {
            // 搜索
            toggleSearch() {
                this.$emit("update:showSearch", !this.showSearch);
            },
            // 刷新
            refresh() {
                this.$emit("queryTable");
            },
            // 右侧列表元素变化
            dataChange(data) {

                for (var item in this.columns) {
                    const key = this.columns[item].key;
                    this.columns[item].visible = !data.includes(key);
                }
            },
            monitorChange(event,label){
                this.columns.filter(item=>item.label==label)[0].isShow=event;

                this.$emit("reDrawTable"); //this.$bus.$emit('showTable',this.pageName);
            }


        },
    };
</script>
<style lang="scss" scoped>
    ::v-deep .el-transfer__button {
        border-radius: 50%;
        padding: 12px;
        display: block;
        margin-left: 0px;
    }
    ::v-deep .el-transfer__button:first-child {
        margin-bottom: 10px;
    }
</style>